import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Box, Card, Divider, Grid } from "@mui/material";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(ArcElement, Tooltip, Legend, Title, ChartDataLabels);

function OutgoingCallDistributionByAgentComponent({ callStatistics }) {
  // Generate unique colors for agents
  const generateColors = (length) => {
    const colors = [];
    for (let i = 0; i < length; i++) {
      const hue = (i * 360) / length;
      colors.push(`hsl(${hue}, 70%, 60%)`);
    }
    return colors;
  };



  // Data preparation
  const agentNames = callStatistics.map((agent) => agent.employeeName);
  const connectedCalls = callStatistics.map(
    (agent) => agent.callStats?.connectedCalls || 0
  );
  const missedCalls = callStatistics.map(
    (agent) => agent.callStats?.notConnectedCalls || 0
  );

  
  const connectedColors = generateColors(agentNames.length);
  const missedColors = generateColors(agentNames.length).map((color) =>
    color.replace("60%", "40%") // Slightly darker shade for missed calls
  );

  const chartData = {
    labels: agentNames,
    datasets: [
      {
        label: "Connected Calls",
        data: connectedCalls,
        backgroundColor: connectedColors,
        borderColor: "#ffffff",
        borderWidth: 2,
      },
      {
        label: "Not-Connected Calls",
        data: missedCalls,
        backgroundColor: missedColors,
        borderColor: "#ffffff",
        borderWidth: 2,
      },
    ],
  };

  const chartOptions = {
    plugins: {
      tooltip: {
        callbacks: {
          label: (context) => {
            const datasetLabel = context.dataset.label || "";
            const value = context.raw || 0;
            return `${datasetLabel}: ${value}`;
          },
        },
      },
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: "Call Distribution by Agent",
        font: { size: 16, weight: "bold" },
      },
      datalabels: {
        color: "#000", // Set datalabels text color
        font: {
          size: 12,
          weight: "bold",
        },
        formatter: (value) => value, // Display the value on the chart
        anchor: "center",
        align: "center",
      },
    },
  };

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Card sx={{ p: 2 }}>
          <h4
            style={{
              fontWeight: "bold",
              fontSize: "18px",
              marginBottom: "16px",
            }}
          >
            Outgoing Call Distribution by Agent
          </h4>
          <Divider sx={{ marginBottom: "16px" }} />
          <Box
            sx={{
              height: "400px",
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Doughnut data={chartData} options={chartOptions} />
          </Box>
        </Card>
      </Grid>
    </Grid>
  );
}

export default OutgoingCallDistributionByAgentComponent;
